import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Form, Checkbox, DatePicker, Select, Button, message, Modal } from 'antd';
import LabelImage from './components/LabelImage';
import moment from 'moment';
import VideoPreview from '../VideoPreview';
import PlusOutlined from '@ant-design/icons';
import { useOrderList } from 'hooks/order-management/order-list';
import SPUploadPhotos from 'components/base/SPUploadPhotos';
import { API_VEHICLE_UPLOAD_PHOTO, API_UPLOAD_ID_CARD, API_UPLOAD_DRIVER_CARD, API_UPLOAD_PR_CAR_VIDEO } from 'hooks/carRental/_';
import CarSeriesInfo from '../components/CarSeriesInfo';
import SPUpload from 'components/base/SPUpload';
import SPTag from 'components/base/SPTag';
import useStore from 'store/base';
import { decryptTextByAES } from 'utils/encryption';

import { getVideoFrameImage } from 'utils/tool';
const CONTRACT_STATUS_MAP = [
  { id: 0, name: '', status: 'processing' },
  { id: 1, name: '待签署', status: 'processing' },
  { id: 2, name: '已签署', status: 'success' },
  { id: 3, name: '已拒签', status: 'error' },
  { id: 4, name: '已撤销', status: 'error' },
  { id: 5, name: '已逾期', status: 'error' },
  { id: 6, name: '签署中', status: 'processing' }
]

const OrderInfo:React.FC<any> = (props) => {

  const { enums } = useStore((state: any) => ({ ...state }));

  const [form] = Form.useForm();


  const [isDamage, setIsDamage]  = useState<boolean>(false);

  const { f_damage_poi_list, f_damage_type_list } = enums || {};

  const { order_info, pickup_material_info } = props?.data || {};

  const { contract_status: contractStatus } = pickup_material_info || {};

  const { pickup_time, order_status } = order_info || {};

  const [thumbSrc, setThumbSrc] = useState<string>('');

  const { pickupCar, sendLinkSubmit, sendContractSubmit, pickupSuccessSubmit, getContractStatusReq, orderDetailRefresh } = useOrderList();

  const handleDamageChecked = (e: any) => {
		setIsDamage(e?.target?.checked);
	}
  const handleSubmit = () => {
    form.validateFields().then(() => {
      const data = form.getFieldsValue();
      const formData = Object.keys(data).reduce((prev: any, next: any) => {
        if (next === 'veh_damage') {
          prev[next] = data[next]?.map((item: any) => ({
            ...item, image: item.image?.file_addr
          }))
        } else if (next === 'contract_image') {
          prev[next] = data[next]?.map((item: any) => item.file_addr).join(',');
        } else {
          prev[next] = data[next]?.file_addr;
        }
        return prev;
      }, {});

      const {
        idcard_front_image,
        idcard_back_image,
        driver_license_homepage,
        driver_license_subpage,
        odometer_image,
        veh_inspection_video,
        front, left_front, left_rear, rear, right_front, right_rear,
        veh_damage,
        center_console, driver_pilot, rear_seats,
        // contract_image
      } = formData;

      const params: any = {
        customer: {
          idcard_front_image,
          idcard_back_image,
          driver_license_homepage,
          driver_license_subpage,
        },
        vehicle: {
          odometer_image,
          veh_inspection_video,
          front,
          left_front,
          left_rear,
          rear,
          right_rear,
          right_front,
          center_console,
          driver_pilot,
          rear_seats,
        },
        // contract_image,
      }
      if (/^http/.test(params?.customer?.idcard_front_image)) {
        delete params?.customer?.idcard_front_image;
      }
      if (/^http/.test(params?.customer?.idcard_back_image)) {
        delete params?.customer?.idcard_back_image;
      }
      if (isDamage) {
        params.veh_damage = veh_damage;
      }
      pickupCar(params, order_info || {}).then((res: any) => {
        message.success('保存信息成功');
      });
    }).catch(() => {
      console.log('表单失败了');
    });
  }

  const handleContractSend = () => {
    const phoneNumber = decryptTextByAES(order_info?.driver_customer?.phone);
    Modal.confirm({
      centered: true,
      title: `电子合同将以短信的形式发送至驾驶人 手机号： ${phoneNumber.substring(0, 3) + '****' + phoneNumber.substring(phoneNumber.length - 4)}`,
      okText: '确认',
      cancelText: '取消',
      onOk: () => sendContractSubmit(order_info || {}),
    });
  }

  const handlePickupSuccess = () => {
    pickupSuccessSubmit(order_info || {});
  }

  const handleContractReSend = () => {
    sendLinkSubmit(order_info || {});
  }

  useEffect(() => {
    if (pickup_material_info?.idcard_back_image) {
      form.setFieldValue('idcard_front_image', pickup_material_info?.idcard_front_image);
    }
    if (pickup_material_info?.idcard_back_image) {
      form.setFieldValue('idcard_back_image', pickup_material_info?.idcard_back_image);
    }
    if (pickup_material_info?.contract_status > 0 || order_status !== 1) {
      const {
        idcard_front_image,
        idcard_back_image,
        driver_license_homepage,
        driver_license_subpage,
      } = pickup_material_info || {};

      const { odometer_image, veh_inspection_video } = pickup_material_info?.veh_info || {};

      const { veh_damage, contract_image } = pickup_material_info || {};

      const {
        front, left_front, left_rear, rear, right_front, right_rear,
      } = pickup_material_info?.veh_outer || {};

      const { center_console, driver_pilot, rear_seats } = pickup_material_info?.veh_interior || {};

      if (veh_damage?.length) {
        setIsDamage(true);
      }
      
      form.setFieldsValue({
        pickup_time: pickup_time ? moment(pickup_time) : '',
        idcard_front_image,
        idcard_back_image,
        driver_license_homepage,
        driver_license_subpage,
        odometer_image,
        veh_inspection_video,
        front, left_front, left_rear, rear, right_front, right_rear,
        veh_damage,
        center_console, driver_pilot, rear_seats,
        contract_image: contract_image?.split(',')
      });
      if (veh_inspection_video) {
        getVideoFrameImage(veh_inspection_video).then((res: any) => {
          setThumbSrc(res);
        })
      }
    }
  }, []);

  const getContractStatus = () => {
    orderDetailRefresh(order_info);
    // getContractStatusReq({ order_code: order_info?.order_code }).then((res) => {
      // const { contract_status } = res?.data || {};
      // setContractStatus(contract_status);
      // if (contract_status === 2) {
        // orderDetailRefresh(order_info);
      // }
    // });
  }

  useEffect(() => {
    getContractStatus();
  }, [])

  const formDisabled = pickup_material_info?.contract_status > 0 || order_status !== 1;
  const targetContractStatus = CONTRACT_STATUS_MAP.find((item: any) => item.id === contractStatus);
  const orderDisabled = order_status !== 1;

  return (
    <>
      <Card title="" style={{ marginBottom: 20 }}>
        <div style={{ display: 'flex', marginBottom: 12 }}>
          <span style={{ fontWeight: 'bold', marginRight: 12 }}>车辆信息:</span>
          <CarSeriesInfo style={{ color: 'rgb(255, 100, 0)' }} orderInfo={order_info} enums={enums} />
        </div>
      </Card>

      <Form form={form} labelCol={{ span: 4 }} disabled={formDisabled} scrollToFirstError>
        <Card title="驾驶员身份证" style={{ marginBottom: 20 }}>
          <Row>
            <Col span={12}>
              <LabelImage label="身份证人面像：" name="idcard_front_image" rules={[{ required: true, message: '请上传身份证人面像' }]} action={API_UPLOAD_ID_CARD} />
            </Col>
            <Col span={12}>
              <LabelImage label="身份证国徽像：" name="idcard_back_image" rules={[{ required: true, message: '请上传身份证国徽像' }]} action={API_UPLOAD_ID_CARD} />
            </Col>
          </Row>
        </Card>
        <Card title="驾驶员行驶证" style={{ marginBottom: 20 }}>
          <Row>
            <Col span={12}>
              <LabelImage label="驾驶证主页：" name="driver_license_homepage" rules={[{ required: true, message: '请上传驾驶证主页' }]} action={API_UPLOAD_DRIVER_CARD} />
            </Col>
            <Col span={12}>
              <LabelImage label="驾驶证副页：" name="driver_license_subpage" rules={[{ required: true, message: '请上传驾驶证副页' }]} action={API_UPLOAD_DRIVER_CARD} />
            </Col>
          </Row>
        </Card>
        <Card title="车辆信息" style={{ marginBottom: 20 }}>
         {order_status > 1 && <Row>
            <Col span={24}>
              <Form.Item
                label="实际取车时间："
                name="pickup_time"
              >
                <DatePicker showTime format="YYYY-MM-DD HH:mm" />
              </Form.Item>
            </Col>
          </Row>}
          <Row>
            <Col span={12}>
              <LabelImage label="里程/油表：" name="odometer_image" rules={[{ required: true, message: '请上传里程/油表' }]} />
            </Col>
            <Col span={12}>
              {/* <LabelImage label="验车视频：" name="veh_inspection_video" /> */}
              <Form.Item
                name="veh_inspection_video"
                label="验车视频："
                rules={[{ required: true, message: ' 请上传验车视频' }]}
              >
                {!formDisabled ? <SPUpload accept='.mp4,.webm,.ogg,.mov' fileType="video" size={200} action={API_UPLOAD_PR_CAR_VIDEO} /> : <VideoPreview thumbSrc={thumbSrc} />}
              </Form.Item>
            </Col>
          </Row>
        </Card>
        <Card title="车辆外观" style={{ marginBottom: 20 }}>
          <Row>
            <Col span={8}>
              <LabelImage label="车头：" name="front" />
            </Col>
            <Col span={8}>
              <LabelImage label="左前：" name="left_front" />
            </Col>
            <Col span={8}>
              <LabelImage label="左后：" name="left_rear" />
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <LabelImage label="尾部：" name="rear" />
            </Col>
            <Col span={8}>
              <LabelImage label="右后：" name="right_rear" />
            </Col>
            <Col span={8}>
              <LabelImage label="右前：" name="right_front" />
            </Col>
          </Row>
          <Form.Item label="是否有车辆损伤" name="interior_damage_checked" valuePropName="checked">
            <Checkbox onChange={handleDamageChecked} />
          </Form.Item>
          {isDamage && <Form.List name="veh_damage" initialValue={[{}]}>
            {(fields, subOpt) => (
              <div style={{ display: 'flex', flexDirection: 'column', rowGap: 16 }}>
                {fields.map((field, index) => (
                  <Row key={index}>
                    <Col span={6}>
                      <Form.Item
                        label="损伤部位"
                        labelCol={{ span: 10 }}
                        name={[field.name, "position"]}
                        rules={[{ required: true, message: '请选择损伤部位' }]}
                      >
                        <Select options={(f_damage_poi_list || []).map((item: any) => ({ label: item.value, value: item.key }))} style={{ width: 180 }} />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        label="损伤类型"
                        labelCol={{ span: 10 }}
                        name={[field.name, "type"]}
                        rules={[{ required: true, message: '请选择损伤类型' }]}
                      >
                        <Select options={(f_damage_type_list || []).map((item: any) => ({ label: item.value, value: item.key }))} style={{ width: 180 }} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <LabelImage name={[field.name, "image"]} label="损伤凭证：" rules={[{ required: true, message: '请上传损伤凭证' }]} />
                    </Col>
                    <Col span={2}>
                      <Button danger onClick={() => {subOpt.remove(field.name);}}>删除</Button>
                    </Col>
                  </Row>
                ))}
                <Button type="dashed" onClick={() => { subOpt.add({}); }} block icon={<PlusOutlined />}>
                  添加损伤部位
                </Button>
              </div>
            )}
          </Form.List>}
        </Card>
        <Card title="车辆内饰" style={{ marginBottom: 20 }}>
          <Row>
            <Col span={8}>
              <LabelImage label="中控台照片：" name="center_console" />
            </Col>
            <Col span={8}>
              <LabelImage label="主/副驾驶照片：" name="driver_pilot" />
            </Col>
            <Col span={8}>
              <LabelImage label="后排座椅照片：" name="rear_seats" />
            </Col>
          </Row>
        </Card>
        <Card title={<>
            <span style={{ marginRight: 12 }}>取车合同</span>
            {targetContractStatus?.name && <SPTag hideIcon text={targetContractStatus.name!} type={ targetContractStatus?.status! } />}
          </>} style={{ marginBottom: 20 }}>
          <Row>
            <Col span={24}>
              {pickup_material_info?.contract_image
                ? (
                  <>
                    <Form.Item
                      label="纸质合同拍照："
                      name="contract_image"
                      rules={[{ required: true, message: '请上传纸质合同' }]}
                    >
                      <SPUploadPhotos hideTitle action={API_VEHICLE_UPLOAD_PHOTO} />
                    </Form.Item>
                  </>
                ) : <>
                  {!contractStatus && <div>确认信息后生成租车合同</div>}
                  {contractStatus === 6 && <div>签署短信已发送至驾驶人手机号,如客户收不到短信: <Button type='link' disabled={false} onClick={handleContractReSend}>点击获取签署链接发送客户</Button></div>}
                  {contractStatus === 2 && <Button type='link' style={{ padding: 0 }} disabled={false} href={pickup_material_info?.contract_path} target='_blank'>点击查看电子合同</Button>}
                  {!orderDisabled && contractStatus > 2 && <Button type="primary" style={{ marginTop: 8 }} disabled={false} onClick={getContractStatus}>刷新合同状态</Button>}
                </>
              }
            </Col>
          </Row>
        </Card>
      </Form>
      {!orderDisabled && <div style={{ marginBottom: 20 }}>
        {/* 合同状态 0-未保存（无意义） 1-待签署，2-已签署，3-已拒签，4-已撤销，5-已逾期 6-签署中 */}
        {!contractStatus && <Button type='primary' disabled={orderDisabled} onClick={handleSubmit}>确认信息</Button>}
        {[1, 3, 4, 5].includes(contractStatus) && <Button type='primary' disabled={orderDisabled} onClick={handleContractSend}>{`${contractStatus !== 1 ? '重新' : ''}`}发送签署短信</Button>}
        {[2, 6].includes(contractStatus) && <Button type='primary' disabled={contractStatus !== 2 || orderDisabled} onClick={handlePickupSuccess}>完成取车</Button>}
      </div>}
    </>
  );
}

export default OrderInfo;
